import axios, { AxiosResponse } from "axios";
import Moneda from "../models/moneda.model";
import { General } from "./general";

export function MonedasService(props?: any) {
    const getMonedas = async (): Promise<AxiosResponse<Moneda[]>> => {
        return axios.post<Moneda[]>(`${General.API_URL}/GetMonedas`);
    }
    return (
        {
            getMonedas,
        }
    );
}
